import Big from "big.js";

// Preview of what a return line is worth. Mirrors lineReturnAmounts in
// backend/src/controllers/serviceReturn.js: the original line's base,
// discount and tax are pro-rated by quantity, and the return that completes a
// line takes what is left of it. The backend recalculates on save.
export const lineReturnAmounts = (line, qty) => {
  const origQty = new Big(line.item_qty || 0);
  const returnQty = new Big(qty || 0);
  if (origQty.lte(0) || returnQty.lte(0)) {
    return { base: 0, discount: 0, tax: 0, total: 0 };
  }

  const origBase = origQty.times(line.item_rate || 0);
  const ratio = returnQty.div(origQty);
  const base = origBase.times(ratio);
  const discount = new Big(line.item_discount || 0).times(ratio);
  const tax = new Big(line.item_tax || 0).times(ratio);
  return {
    base: Number(base),
    discount: Number(discount),
    tax: Number(tax),
    total: Number(base.minus(discount).plus(tax)),
  };
};

export const returnTotals = (lines) =>
  (lines || []).reduce(
    (acc, line) => {
      const a = lineReturnAmounts(line, line.return_qty);
      return {
        subTotal: acc.subTotal + a.base,
        discount: acc.discount + a.discount,
        tax: acc.tax + a.tax,
        total: acc.total + a.total,
      };
    },
    { subTotal: 0, discount: 0, tax: 0, total: 0 }
  );
